import { DashboardThumbnail } from '../ui/dashboard/thumbnail-group'

const MAX_VISIBLE_THUMBNAILS = 3
const LAST_VISIBLE_INDEX = MAX_VISIBLE_THUMBNAILS - 1

export const formatThumbnailsForDisplay = (
  thumbnails: string[],
  count: number,
): DashboardThumbnail[] => {
  return thumbnails.slice(0, MAX_VISIBLE_THUMBNAILS).map((url, index) => {
    const isMoreThanMaxVisibleThumbnails = count > MAX_VISIBLE_THUMBNAILS

    const moreCount = isMoreThanMaxVisibleThumbnails
      ? count - LAST_VISIBLE_INDEX
      : 0
    const showMoreCount =
      index === LAST_VISIBLE_INDEX && isMoreThanMaxVisibleThumbnails

    return {
      url,
      moreCount,
      showMoreCount,
    }
  })
}
